import { c as _c } from "react/compiler-runtime";
export default function Home(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M1.107 16.553A1 1 0 0 0 2.001 18h3.982v8c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-8h4c.3 0 .7-.2.9-.5.2-.3.1-.6 0-.9l-6-12c-.2-.4-.5-.6-.9-.6h-16c-.4 0-.7.2-.9.6L1.107 16.553zM23.983 25h-16v-7h16v7zm-20.4-9l5-10h14.8l5 10h-24.8z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}